// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Montserrat-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Montserrat-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Montserrat-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Montserrat-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Exo2-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Exo2-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Exo2-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Exo2-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Montserrat-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Montserrat-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Montserrat-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Montserrat-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Montserrat-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Montserrat-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/Bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/greenbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* --------------------------------------
   Fonts
--------------------------------------- */
@font-face {
  font-family: "Montserrat italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 100;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Exo Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Exo italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
/* --------------------------------------
   Variables
--------------------------------------- */
/* Font aliases */
/* --------------------------------------
   Mixins
--------------------------------------- */
/* --------------------------------------
   Reset CSS (Meyer reset + tweaks)
--------------------------------------- */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  color: inherit;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1.5;
  font-family: "Montserrat-Regular";
  color: #11173e;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote::before,
blockquote::after,
q::before,
q::after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* --------------------------------------
   Global Helpers
--------------------------------------- */
* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: inherit;
}
a:hover, a:active, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

b,
strong,
th,
.bold-text {
  font-weight: 700;
}

.left {
  float: left;
}

.right {
  float: right;
}

.clearfix::after,
.wrap-clear::after {
  content: "";
  display: table;
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea,
select {
  border-radius: 0;
  appearance: none;
}

textarea {
  resize: none;
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
}

/* Show/hide helpers */
.tablet {
  display: none;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .tablet {
    display: block;
  }
}

.desktop {
  display: none;
}
@media (min-width: 1025px) and (max-width: 1399px) {
  .desktop {
    display: block;
  }
}

.mobile {
  display: none;
}
@media (max-width: 767px) {
  .mobile {
    display: block;
  }
}

/* --------------------------------------
   Layout
--------------------------------------- */
.container {
  width: 100%;
  margin: 0 auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media (max-width: 575px) {
  .container {
    max-width: 100%;
    padding-left: 12px;
    padding-right: 12px;
  }
}
@media (max-width: 767px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 1025px) and (max-width: 1399px) {
  .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.screen {
  max-width: 400px;
  margin: 40px auto;
  padding: 20px;
  text-align: center;
  font-family: Arial, sans-serif;
  background: #f8e287; /* light golden background */
  border-radius: 12px;
}

input[type=radio i] {
  margin: 0;
}

input[type=text],
input[type=number],
input[type=password],
input[type=tel],
input[type=email] {
  display: block;
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 25px;
  border: none;
  outline: none;
  text-align: center;
  font-size: 16px;
}

button {
  width: 100%;
  padding: 14px;
  margin-top: 12px;
  border: none;
  border-radius: 25px;
  background: linear-gradient(#0e800f, #045504);
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}
button:hover {
  background: linear-gradient(#0c660c, #034603);
}

button:disabled,
button[disabled] {
  background: gray;
  cursor: not-allowed;
}

/* Prevent hover color change for disabled buttons */
button:disabled:hover,
button[disabled]:hover {
  background: gray;
}

label {
  display: block;
  font-size: 10px;
  text-align: left;
}

.radio-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 5px;
}

h2 {
  color: #222;
}

p {
  font-size: 14px;
  color: #333;
}

.back-btn {
  width: auto;
  padding: 8px 16px;
  margin-top: 12px;
  border-radius: 20px;
  background: black;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.main-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  padding-top: 120px;
}
@media (max-width: 767px) {
  .main-bg {
    padding-bottom: 55px;
  }
}

.home-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px;
}
.home-wrapper img {
  width: 250px;
  margin-bottom: 20px;
}

.input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  z-index: 1;
}
.input-wrapper input {
  width: 100%;
  padding-right: 30px; /* space for tooltip icon */
  box-sizing: border-box;
}
.input-wrapper .tooltip {
  position: absolute;
  right: 8px;
  top: 40%;
  transform: translateY(-50%);
  cursor: pointer;
  font-weight: bold;
  color: rgba(102, 102, 102, 0.8274509804);
}
.input-wrapper .tooltiptext {
  visibility: hidden;
  width: 160px;
  background: #333;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
  position: absolute;
  top: -40px;
  right: 0;
  z-index: 1;
  font-size: 12px;
}
.input-wrapper .tooltip:hover .tooltiptext {
  visibility: visible;
}

.flex-common {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 50px;
}
.flex-common h2 {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: "Montserrat-Regular";
}

.logo-main {
  max-width: 240px;
  margin-bottom: 20px;
}

.instructions-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-position-x: left;
  background-size: 60%;
}
.instructions-wrapper .logo-main {
  width: 250px;
}
.instructions-wrapper .wrapper {
  padding: 0 40px;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  text-align: center;
  gap: 50px;
}
.instructions-wrapper h2 {
  font-size: 30px;
  font-family: "Montserrat-Regular";
}
.instructions-wrapper p {
  margin-top: 10px;
  font-size: 15px;
  line-height: 1.3;
  max-width: 250px;
  text-align: center;
}
.instructions-wrapper .fifty-six {
  font-size: 50px;
  border: 1px solid rgba(43, 42, 42, 0.412);
  border-radius: 50%;
  padding: 10px;
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
}
.instructions-wrapper .btn-next {
  background: transparent;
  padding: 0;
  color: black;
  font-weight: bold;
}
.instructions-wrapper .circle-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 15px;
  margin-top: 10px;
}
.instructions-wrapper .circle-right {
  margin-left: -18px;
  line-height: 1.1;
  background: #d2ac48;
}

.win-wrapper {
  padding: 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.win-wrapper .win-img {
  width: 300px;
}
.win-wrapper button {
  width: max-content;
}
.win-wrapper h2 {
  font-weight: bold;
  font-size: 30px;
}
.win-wrapper p {
  text-align: center;
  font-size: 18px;
  line-height: 1.3;
}

.back-btn {
  background: black;
  border: 0;
  max-width: fit-content;
  font-size: 12px;
  border-radius: 20px;
  padding: 3px 5px;
}

/* Container */
.form-container {
  max-width: 420px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: "Arial", sans-serif;
}

.footer-line {
  bottom: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
  font-size: 10px;
  margin-top: 50px;
  padding: 12px 8px;
}
@media (max-width: 767px) {
  .footer-line {
    font-size: 8px;
  }
}
.footer-line .bottom-footer-line {
  margin-top: 0;
  margin-top: 10px;
}
@media (max-width: 767px) {
  .footer-line .bottom-footer-line {
    margin-top: 10px;
  }
}

/* Form Card */
.form-card {
  display: flex;
  flex-direction: column;
  padding: 0 40px;
}

/* Inputs */
.form-card input[type=text],
.form-card input[type=number],
.form-card input[type=tel],
.form-card input[type=password] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease;
  font-family: "Montserrat-Regular";
}

.form-card input:focus {
  border-color: #28a745;
}

/* Error messages */
.error {
  font-size: 13px;
  color: #b30000;
  margin: -10px 0 8px 4px;
  text-align: center;
}

/* Radio group */
.radio-group {
  margin-bottom: 10px;
}

.radio-label {
  display: block;
  font-weight: 600;
  font-family: "Montserrat-Regular";
}

.radio-group label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
}

/* Custom radio */
.radio-group input[type=radio] {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #000000;
  background: white;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  position: relative;
}

.radio-group input[type=radio]:checked {
  border-color: #28a745;
  background-color: #28a745;
  border: 1px solid black;
}

.radio-group input[type=radio]:checked::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  border-radius: 50%;
}

/* Checkbox group */
.checkbox-group {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 10px;
}

.flex-label {
  display: flex;
  gap: 10px;
  font-family: "Montserrat-Regular";
  cursor: pointer;
  align-items: flex-start;
}

/* Custom checkbox wrapper */
.custom-checkbox-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

/* Hide the default checkbox */
.custom-checkbox-wrapper input[type=checkbox] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
}

/* Custom checkbox design */
.custom-checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid #000;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

/* Checkmark using ::after */
.custom-checkbox::after {
  content: "✓";
  font-size: 14px;
  font-weight: bold;
  color: #28a745;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease;
}

/* Show checkmark when checked */
.custom-checkbox-wrapper input[type=checkbox]:checked + .custom-checkbox::after {
  opacity: 1;
  transform: scale(1);
}

/* Optional: Add background color when checked */
.custom-checkbox-wrapper input[type=checkbox]:checked + .custom-checkbox {
  background: #f0f9f4;
  border-color: #28a745;
}

/* Optional: Focus state for accessibility */
.custom-checkbox-wrapper input[type=checkbox]:focus + .custom-checkbox {
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
}

.checkbox-text {
  line-height: 1.5;
}

/* Submit / Buttons */
.submit-btn,
button {
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: #fff;
  border: none;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 12px;
  transition: background 0.3s ease;
  font-family: "Montserrat-Regular";
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-btn:hover,
button:hover {
  background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);
}

/* Instructions */
.instruction-step {
  text-align: center;
  padding: 20px;
}

.instruction-step h2 {
  margin-bottom: 12px;
  font-size: 20px;
}

.instruction-step p {
  margin-bottom: 20px;
  font-size: 15px;
  color: #444;
}

/* Layout */
.page {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* Layout */
}
.page .logo-img {
  width: 300px;
}
.page .wrap {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}
.page {
  /* Controls */
}
.page .controls {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px;
  justify-content: center;
  flex-direction: column;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.page .wrapper-btn {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px;
  justify-content: center;
  align-items: center;
}
.page .btn,
.page .filebtn {
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.page .shuffle-btn,
.page .reset-btn {
  max-width: 120px;
}
.page {
  /* Board */
}
.page .board-outer {
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  max-width: 340px;
}
.page .board {
  /* square board */
  position: relative;
  width: 100%;
  padding-top: 100%; /* aspect-square */
  overflow: hidden;
}
.page {
  /* 2x2 grid using absolute children */
}
.page .tile {
  position: absolute;
  width: calc(50% - 1px); /* 2px gap total => 1px each side */
  height: calc(50% - 1px);
  background-size: 200% 200%;
  background-repeat: no-repeat;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) inset;
  border: 1px solid transparent;
}
.page .tile.dragging {
  opacity: 0.85;
}
.page {
  /* place tiles in a 2x2 with 2px gaps */
}
.page .slot-0 {
  left: 0;
  top: 0;
}
.page .slot-1 {
  left: calc(50% + 1px);
  top: 0;
}
.page .slot-2 {
  left: 0;
  top: calc(50% + 1px);
}
.page .slot-3 {
  left: calc(50% + 1px);
  top: calc(50% + 1px);
}
.page {
  /* the subtle ring */
}
.page .tile::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  pointer-events: none;
}

.result-block {
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 5px;
}
.result-block .main-logo {
  width: 250px;
}
.result-block .poster {
  position: relative;
  width: 200px; /* अपनी इमेज जितना */
  height: 150px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center/contain;
  /* no-repeat और cover से पूरी div पर इमेज फिट होगी */
}
.result-block {
  /* टेक्स्ट को बीच में लाने के लिए */
}
.result-block .overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff; /* इमेज के हिसाब से रंग चुनें */
  width: 70%;
  font-size: 12px;
}
.result-block .overlay-text p {
  color: yellow;
  line-height: 1.3;
}
.result-block .overlay-text a {
  color: yellow;
}
.result-block h2 {
  font-size: 30px;
  text-transform: uppercase;
  line-height: 1.3;
  color: #056a35;
  text-shadow: #ffe200 1px 1px;
  font-family: "Montserrat-Regular";
}
.result-block .win-img {
  width: 180px;
  margin-top: 20px;
}

.form-container-ret {
  width: 100%;
  padding: 20px;
}
.form-container-ret .wrapper-form {
  padding: 0 20px;
  position: relative;
  max-width: 480px;
  margin: 0 auto;
}
.form-container-ret .logo-main {
  width: 250px;
  margin-top: 30px;
}
.form-container-ret .page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center/cover;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-container-ret .container {
  width: 350px;
  background: rgba(255, 215, 130, 0.92);
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px 20px;
}
.form-container-ret .test {
  color: black;
}
.form-container-ret .logo {
  font-size: 32px;
  font-weight: bold;
  color: #064f24;
  margin: 0;
  font-family: cursive;
}
.form-container-ret .subtitle {
  font-size: 18px;
  font-weight: 600;
  margin: 5px 0 20px;
  color: #222;
}
.form-container-ret .tabs {
  display: flex;
  background: #fff;
  border-radius: 25px;
  overflow: hidden;
  padding: 5px;
  margin-bottom: 10px;
}
.form-container-ret .tabs button {
  flex: 1 1;
  padding: 10px;
  border: none;
  background: transparent;
  font-weight: 600;
  cursor: pointer;
}
.form-container-ret .tabs button.active {
  background: linear-gradient(90deg, #c8a74c, #e3c97a);
  color: #fff;
  border-radius: 25px;
}
.form-container-ret button {
  margin: 0;
}
.form-container-ret .login {
  color: black;
}
.form-container-ret .test {
  color: black;
}
.form-container-ret form {
  display: flex;
  flex-direction: column;
}
.form-container-ret input {
  margin: 8px 0;
  padding: 12px;
  border: none;
  border-radius: 25px;
  outline: none;
  font-size: 14px;
}
.form-container-ret .verifyBtn {
  margin-top: 10px;
  padding: 12px;
  border: none;
  border-radius: 25px;
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.form-container-ret .verifyBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.form-container-ret .error {
  margin-top: 10px;
  font-size: 13px;
  color: #b30000;
}
.form-container-ret.success-screen {
  text-align: center;
}
.form-container-ret.success-screen .retailer-code {
  color: black;
  font-weight: bold;
  font-size: 60px;
}

.dashboard-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  margin: 0 auto;
  text-align: center;
  border-radius: 12px;
  padding: 20px;
  padding-top: 100px;
  padding-bottom: 80px;
}
.dashboard-container .content-wrap {
  max-width: 480px;
  margin: 0 auto;
}
.dashboard-container .retailer-wrapper {
  background-color: #e9d5a3;
  padding: 20px;
  border-radius: 15px;
  margin-top: 20px;
}
.dashboard-container .loader {
  margin: 40px auto;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.dashboard-container .logo-main {
  max-width: 240px;
  margin-bottom: 20px;
  margin-top: 30px;
}
.dashboard-container .subtitle {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.dashboard-container .retailer-info {
  border-radius: 10px;
  margin-bottom: 20px;
  font-size: 12px;
  text-align: left;
  position: relative;
  background: #efe2bf;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.dashboard-container .retailer-info h1 {
  font-size: 18px;
  font-family: "Montserrat-Bold";
}
.dashboard-container .logoutBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  cursor: pointer;
  transition: 0.3s;
  width: max-content;
}
.dashboard-container .logoutBtn:hover {
  background: #333;
}
.dashboard-container .stats {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.dashboard-container .stats .rank-card {
  background: linear-gradient(135deg, #e0ad3a, #a66b00);
  color: white;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.dashboard-container .stats .rank-title {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 5px;
  letter-spacing: 1px;
}
.dashboard-container .stats .rank-values {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.dashboard-container .stats .rank-section {
  flex: 1 1;
}
.dashboard-container .stats .rank-label {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.8;
}
.dashboard-container .stats .rank-number {
  font-size: 22px;
  margin-top: 4px;
  font-family: "Montserrat-Bold";
  color: white;
}
.dashboard-container .stats .divider {
  width: 1px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.4);
}
.dashboard-container .card {
  flex: 1 1;
  background: white;
  background: #ba8a0d;
  background: linear-gradient(111deg, rgb(186, 138, 13) 0%, rgba(201, 156, 39, 0.87) 85%, rgb(186, 138, 13) 100%);
  padding: 7px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dashboard-container .card p {
  font-size: 12px;
  color: #444;
  text-align: center;
  color: white;
}
.dashboard-container .card h3 {
  margin: 5px 0 0;
  font-size: 24px;
  font-family: "Montserrat-Bold";
  color: white;
  line-height: 1.4;
}
.dashboard-container .cashbackBtn {
  max-width: max-content;
  padding: 12px 50px;
  margin: 20px 0;
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: white;
  border: none;
  border-radius: 15px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  font-family: "Montserrat-Bold";
}
.dashboard-container .cashbackBtn:hover {
  background: darkgreen;
  color: white;
}
.dashboard-container .leaderboard {
  background: #be9426;
  padding: 10px;
  border-radius: 10px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid #efe2bf;
}
.dashboard-container .leaderboard h2 {
  font-size: 24px;
  text-align: left;
  color: white;
  font-family: "Montserrat-Bold";
  text-align: center;
  margin-bottom: 15px;
}
.dashboard-container .leaderboard table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.dashboard-container .leaderboard th,
.dashboard-container .leaderboard td {
  padding: 8px;
  text-align: center;
  font-size: 16px;
}
.dashboard-container .leaderboard th {
  font-family: "Montserrat-Bold";
  font-size: 16px;
}

.admin-dashboard {
  padding: 20px;
  background: #f8f8f8;
  min-height: 100vh;
}
.admin-dashboard .bg-main-table {
  background: #ae8a28;
  background: linear-gradient(130deg, rgb(174, 138, 40) 0%, rgb(200, 153, 39) 100%);
  border: 2px solid #ecddaf;
  border-radius: 10px;
}
.admin-dashboard .total-entries {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}
.admin-dashboard .total-entries .title-retailers {
  flex: 1 1;
}
.admin-dashboard .wrapper-top-titles {
  display: grid;
  grid-template-columns: repeat(3, 3fr);
  gap: 20px;
}
.admin-dashboard .white-box {
  padding: 5px 10px;
  font-size: 18px;
  font-family: "Montserrat-Bold";
}
.admin-dashboard .title-retailers {
  padding: 20px 0;
  border-radius: 10px;
  background: #f3ecd4;
  background: linear-gradient(130deg, rgb(243, 236, 212) 0%, rgb(234, 220, 171) 100%);
  font-family: "Montserrat-Regular";
}
.admin-dashboard .admin-dashboard h1 {
  margin-bottom: 20px;
  color: #333;
}
.admin-dashboard .admin-table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.admin-dashboard .admin-table th,
.admin-dashboard .admin-table td {
  padding: 12px;
  text-align: left;
  font-size: 14px;
}
.admin-dashboard .admin-table th {
  font-size: 16px;
}
.congrats-page {
  max-width: 100%;
  width: 100%;
  margin: 20px auto;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
}
.congrats-page h2 {
  color: #0b6535;
  font-size: 30px;
  text-shadow: yellow 1px 1px;
  font-weight: bold;
}
.congrats-page .tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.congrats-page p {
  font-weight: bold;
}
.congrats-page .tabs button {
  flex: 1 1;
  padding: 10px;
  border: none;
  background: white;
  cursor: pointer;
  font-weight: bold;
  color: black;
  margin: 0;
}
.congrats-page .tabs button.active {
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: white;
}
.congrats-page .entries-table {
  background: #be9426;
  padding: 10px;
  border-radius: 10px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid #efe2bf;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
}
.congrats-page .entries-table h3 {
  font-family: "Montserrat-Bold";
  font-size: 22px;
  text-transform: uppercase;
}
.congrats-page .entries-table .table-content {
  overflow-x: scroll;
}
.congrats-page .entries-table table thead tr th {
  text-align: center;
}
.congrats-page .entries-table table tbody tr td {
  text-align: center;
}
.congrats-page .entries-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.congrats-page .entries-table th,
.congrats-page .entries-table td {
  padding: 8px;
  text-align: left;
}
.congrats-page .entries-table tr:last-child {
  border-bottom: none;
}

.backBtn-wrapper .backBtn {
  display: flex;
  font-family: "Montserrat-Regular";
  margin-bottom: 20px;
  align-items: center;
  background-color: black;
  color: white;
  max-width: max-content;
  padding: 5px 10px;
  border-radius: 50px;
}
.backBtn-wrapper .backBtn p {
  color: white;
}

.language-selector-wrapper {
  display: none;
}

.language-selector-bottom {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.language-dropdown-bottom {
  padding: 8px 32px 8px 16px;
  border: 2px solid #f7f2f2;
  border-radius: 25px;
  background: linear-gradient(90deg, #c8a74c, #e3c97a);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  min-width: 120px;
  text-align: center;
  appearance: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.language-dropdown-bottom option {
  background: #fff;
  color: #333;
  padding: 8px;
}
.language-dropdown-bottom option:hover {
  background: #f0f0f0;
}
.language-dropdown-bottom option:checked {
  background: #e3c97a;
  color: #fff;
}

.language-dropdown-bottom:focus {
  outline: none;
  border-color: #0a4c17;
  box-shadow: 0 0 0 3px rgba(10, 76, 23, 0.3);
}

.language-dropdown-bottom:hover {
  opacity: 0.9;
}

.arrow-wrapper-bottom {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #fff;
}
.arrow-wrapper-bottom .dropdown-icon {
  font-size: 12px;
}

.timer-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 20px 0;
  width: 100%;
}

.timer-badge {
  background-color: #1a5f1a;
  border-radius: 25px;
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.timer-label {
  color: white;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

.timer-value {
  color: white;
  font-size: 48px;
  font-weight: bold;
  line-height: 1;
}

.timer-text {
  color: #333;
  font-size: 20px;
  font-weight: 500;
}

.game-result {
  margin-top: 15px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.puzzle-preview {
  width: 80px;
  height: 80px;
  border: 1px solid #ccc;
  overflow: hidden;
  margin-right: 10px;
}
.puzzle-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.claim-cashback {
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: white;
  padding: 4px;
  border-radius: 4px;
}
.claim-cashback:hover {
  background: darkgreen;
  color: white;
}

.claim-cashback-lg {
  font-size: 16px;
  padding: 6px 12px;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.tooltip-container {
  position: absolute;
  right: 12px;
  top: 25%;
  transform: translateY(-25%);
  display: inline-block;
  z-index: 100;
}

.tooltip-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  cursor: help;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tooltip-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.tooltip-content {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  width: 280px;
  max-width: 90vw;
  background: #ffffff;
  color: #333;
  padding: 16px 20px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  z-index: 99999;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
  transform: translate(-100%, -100%) scale(1);
}

/* Optional: Add backdrop */
.tooltip-container:hover::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9998;
}

.tnc-link {
  margin-top: 10px;
  font-size: 12px;
}

.terms-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  font-family: "Montserrat-Regular";
}

.terms-header {
  text-align: center;
  margin-bottom: 40px;
}

.terms-logo {
  max-width: 150px;
  margin-bottom: 15px;
}

.terms-header h1 {
  color: #2c3e50;
  font-size: 24px;
  margin: 0;
  font-family: "Montserrat-Bold";
}

.terms-content {
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.terms-list {
  counter-reset: item;
  list-style: none;
  padding-left: 0;
}

.terms-list > li {
  counter-increment: item;
  margin-bottom: 20px;
  padding-left: 40px;
  position: relative;
  line-height: 1.7;
  color: #34495e;
  font-size: 14px;
  text-align: justify;
}

.terms-list > li::before {
  content: counter(item) ".";
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 700;
  color: #2c3e50;
  font-size: 16px;
}

.sub-list {
  margin-top: 15px;
  padding-left: 20px;
  list-style-type: upper-alpha;
}

.sub-list li {
  margin-bottom: 12px;
  line-height: 1.7;
  color: #34495e;
  font-size: 14px;
}

.privacy-link {
  color: #3498db;
  text-decoration: none;
  word-break: break-all;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: #2980b9;
  text-decoration: underline;
}

.terms-footer {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

.back-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
}

.back-button:active {
  transform: translateY(0);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .terms-container {
    padding: 15px;
  }
  .terms-content {
    padding: 20px 15px;
  }
  .terms-header h1 {
    font-size: 20px;
  }
  .terms-list > li {
    font-size: 13px;
    padding-left: 30px;
  }
  .sub-list li {
    font-size: 13px;
  }
  .back-button {
    padding: 12px 30px;
    font-size: 14px;
  }
}
.checkbox-text {
  font-size: 12px;
}

.tnc {
  text-decoration: underline;
  font-family: "Montserrat-Bold";
}

.cashback-section {
  margin-top: 10px;
  margin-bottom: 10px;
}

.admin-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #d4af68 0%, #c9a55a 100%);
  padding: 20px;
}
.admin-dashboard__header {
  text-align: center;
  margin-bottom: 30px;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
.admin-dashboard__tab-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 30px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}
.admin-dashboard__export-btn,
.admin-dashboard button {
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 12px;
  transition: background 0.3s ease;
  font-family: "Montserrat-Regular";
}
.admin-dashboard__export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.admin-dashboard__export-btn:hover,
.admin-dashboard button:hover {
  background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);
}
.admin-dashboard__tab-button {
  flex: 1 1;
  max-width: 600px;
  padding: 15px 30px;
  border: none;
  background: #ffffff;
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  color: #1a1a1a;
  border-radius: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.admin-dashboard__tab-button--active {
  background: #1a5f3a;
  color: #ffffff;
  box-shadow: 0 6px 12px rgba(26, 95, 58, 0.3);
}
.admin-dashboard__tab-button:hover:not(.admin-dashboard__tab-button--active) {
  background: #f5f5f5;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.admin-dashboard__content {
  max-width: 1400px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.95);
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}
.admin-dashboard__section-title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
}
.admin-dashboard__filter-container {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: 25px;
  padding: 20px;
  background: rgba(212, 175, 104, 0.1);
  border-radius: 12px;
}
.admin-dashboard__filter-group {
  display: flex;
  flex-direction: column;
}
.admin-dashboard__filter-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.admin-dashboard__input {
  padding: 10px 15px;
  width: 220px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: #1a1a1a;
}
.admin-dashboard__input:focus {
  outline: none;
  border-color: #1a5f3a;
  box-shadow: 0 0 0 3px rgba(26, 95, 58, 0.1);
}
.admin-dashboard__input::placeholder {
  color: #6c757d;
}
.admin-dashboard__date-input {
  padding: 10px 15px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: #1a1a1a;
}
.admin-dashboard__date-input:focus {
  outline: none;
  border-color: #1a5f3a;
  box-shadow: 0 0 0 3px rgba(26, 95, 58, 0.1);
}
.admin-dashboard__apply-button {
  padding: 10px 24px;
  background: #1a5f3a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(26, 95, 58, 0.2);
}
.admin-dashboard__apply-button:hover {
  background: #2d7a4f;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(26, 95, 58, 0.3);
}
.admin-dashboard__apply-button:active {
  transform: translateY(0);
}
.admin-dashboard__table-wrapper {
  overflow-x: auto;
  margin-bottom: 25px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.admin-dashboard__table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
}
.admin-dashboard__table-head {
  background: linear-gradient(135deg, #d4af68 0%, #c9a55a 100%);
}
.admin-dashboard__table-header {
  padding: 16px 12px;
  text-align: left;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  font-weight: 700;
  color: #1a1a1a;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.admin-dashboard__table-row {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.2s ease;
}
.admin-dashboard__table-row:hover {
  background: rgba(212, 175, 104, 0.08);
}
.admin-dashboard__table-row:last-child {
  border-bottom: none;
}
.admin-dashboard__table-cell {
  padding: 14px 12px;
  color: #4a4a4a;
  font-size: 14px;
}
.admin-dashboard__empty-cell {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
  font-size: 15px;
}
.admin-dashboard__loading {
  padding: 40px 20px;
  text-align: center;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 500;
}
.admin-dashboard__pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  padding: 20px;
  background: rgba(212, 175, 104, 0.1);
  border-radius: 12px;
}
.admin-dashboard__pagination-info {
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 500;
}
.admin-dashboard__pagination-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}
.admin-dashboard__pagination-button {
  padding: 10px 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: #ffffff;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  transition: all 0.3s ease;
}
.admin-dashboard__pagination-button:hover:not(:disabled) {
  background: #1a5f3a;
  color: #ffffff;
  border-color: #1a5f3a;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(26, 95, 58, 0.2);
}
.admin-dashboard__pagination-button:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.5;
  color: #6c757d;
  border-color: #e0e0e0;
}
.admin-dashboard__pagination-text {
  padding: 10px 16px;
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
}
.admin-dashboard .tabs-wrap {
  margin-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #0a4c17;
}
.admin-dashboard .tabs-wrap button {
  margin: 0 !important;
}
.admin-dashboard .tabs-wrap .tab {
  padding: 12px 24px;
  cursor: pointer;
  font-weight: 500;
  color: #000;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.admin-dashboard .tabs-wrap .tab:hover {
  color: #374151;
  border-bottom-color: #6b7280;
}
.admin-dashboard .tabs-wrap .tab.active {
  color: #0a4c17;
  border-bottom-color: #0a4c17;
  font-family: "Montserrat-Bold";
}

@media (max-width: 768px) {
  .admin-dashboard {
    padding: 15px;
  }
  .admin-dashboard__tab-container {
    flex-direction: column;
    gap: 15px;
  }
  .admin-dashboard__tab-button {
    max-width: 100%;
  }
  .admin-dashboard__content {
    padding: 20px 15px;
  }
  .admin-dashboard__filter-container {
    flex-direction: column;
    align-items: stretch;
  }
  .admin-dashboard__input {
    width: 100%;
  }
  .admin-dashboard__pagination-container {
    flex-direction: column;
    text-align: center;
  }
}
.btn-home {
  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);
  color: #fff;
  border: none;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 12px;
  transition: background 0.3s ease;
  font-family: "Exo Regular";
}
.btn-home:hover {
  background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);
  color: white;
}

.otp-block {
  width: 100%;
  text-align: center;
  margin-top: 40px;
}

.privacy-policy-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px 20px;
}
.privacy-policy-container .privacy-policy-content {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .privacy-policy-container .privacy-policy-content {
    padding: 20px;
  }
}
.privacy-policy-container .privacy-policy-content .main-title {
  font-size: 28px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 20px;
  line-height: 1.3;
  text-align: center;
}
@media (max-width: 768px) {
  .privacy-policy-container .privacy-policy-content .main-title {
    font-size: 22px;
  }
}
.privacy-policy-container .privacy-policy-content .effective-date {
  text-align: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}
.privacy-policy-container .privacy-policy-content .intro-text {
  font-size: 14px;
  line-height: 1.6;
  color: #34495e;
  margin-bottom: 20px;
}
.privacy-policy-container .privacy-policy-content .policy-section {
  margin-bottom: 35px;
}
.privacy-policy-container .privacy-policy-content .policy-section h2 {
  font-size: 22px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 15px;
  padding-bottom: 8px;
}
@media (max-width: 768px) {
  .privacy-policy-container .privacy-policy-content .policy-section h2 {
    font-size: 20px;
  }
}
.privacy-policy-container .privacy-policy-content .policy-section p {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 15px;
}
.privacy-policy-container .privacy-policy-content .policy-section ul {
  margin-left: 20px;
  margin-bottom: 15px;
}
.privacy-policy-container .privacy-policy-content .policy-section ul li {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 8px;
}
.privacy-policy-container .privacy-policy-content .policy-section a {
  color: #4a7dcc;
  text-decoration: none;
  font-weight: 500;
}
.privacy-policy-container .privacy-policy-content .policy-section a:hover {
  text-decoration: underline;
}
.privacy-policy-container .privacy-policy-content .policy-section .subsection {
  margin-bottom: 20px;
}
.privacy-policy-container .privacy-policy-content .policy-section .subsection h3 {
  font-size: 18px;
  font-weight: 600;
  color: #2c2c2c;
  margin-bottom: 10px;
}
.privacy-policy-container .privacy-policy-content .policy-section .contact-info {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 6px;
  border-left: 4px solid #4a7dcc;
}
.privacy-policy-container .privacy-policy-content .policy-section .contact-info p {
  margin-bottom: 10px;
}
.privacy-policy-container .privacy-policy-content .policy-section .contact-info p:last-child {
  margin-bottom: 0;
}
.privacy-policy-container .privacy-policy-content .consent-notice {
  background-color: #fff9e6;
  border: 2px solid #ffd700;
  border-radius: 6px;
  padding: 20px;
  margin-top: 30px;
}
.privacy-policy-container .privacy-policy-content .consent-notice .checkbox-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.privacy-policy-container .privacy-policy-content .consent-notice .checkbox-wrapper .privacy-checkbox {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-top: 2px;
  cursor: pointer;
  flex-shrink: 0;
  appearance: auto;
  -webkit-appearance: checkbox;
  -moz-appearance: checkbox;
}
.privacy-policy-container .privacy-policy-content .consent-notice .checkbox-wrapper .checkbox-label {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  flex: 1 1;
}

.resend-otp-section {
  margin-top: 15px;
  text-align: center;
}
.resend-otp-section .timer-text {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.resend-otp-section .timer-text .timer-count {
  font-family: "Montserrat-Bold";
  color: black;
}
.resend-otp-section .resend-btn {
  margin-top: 10px;
}
.resend-otp-section .resend-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pagination__controls {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.pagination__button {
  padding: 4px 8px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  border-radius: 8px;
  color: black;
}
.pagination__button--disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  color: #666;
}
.pagination__info {
  padding: 8px 12px;
}

.admin-login h2 {
  font-family: "Montserrat-Bold";
}
.admin-login .form-card {
  width: calc(100% - 20px);
}

.cancel-btn {
  background: #000;
}
.cancel-btn:hover {
  background: gray;
}

.password-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.password-modal__content {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.password-modal__title {
  margin-bottom: 10px;
  font-size: 20px;
  color: #333;
}
.password-modal__description {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}
.password-modal__form {
  display: flex;
  flex-direction: column;
}
.password-modal input {
  border: 1px solid rgb(204, 204, 204);
}
.password-modal__input {
  width: 100%;
  padding: 12px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 8px !important;
  font-size: 14px;
  margin-bottom: 15px;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}
.password-modal__input:focus {
  outline: none;
}
.password-modal__input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}
.password-modal__input::placeholder {
  color: #999;
}
.password-modal__error {
  background-color: #fee;
  color: #c33;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 15px;
  font-size: 14px;
  border: 1px solid #fcc;
  animation: shake 0.3s;
}
.password-modal__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.password-modal__button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}
.password-modal__button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.password-modal__button--cancel {
  color: white;
  background: #000;
}
.password-modal__button--cancel:hover {
  background: gray;
}
.password-modal__button--cancel:disabled {
  opacity: 0.6;
}
.password-modal__button--submit {
  border: none;
  color: white;
}
.password-modal__button--submit:hover:not(:disabled) {
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);
}
.password-modal__button--submit:disabled {
  background-color: #ccc;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}
@media (max-width: 768px) {
  .password-modal__content {
    padding: 20px;
    width: 95%;
  }
  .password-modal__title {
    font-size: 18px;
  }
  .password-modal__description {
    font-size: 13px;
  }
  .password-modal__button {
    padding: 12px 16px;
    font-size: 13px;
  }
}
.screen-count-table {
  min-height: 280px;
}

.popover-content {
  background-color: white;
  color: black;
  padding: 16px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  max-width: 320px;
  box-shadow: 0 10px 38px -10px rgba(0, 0, 0, 0.35);
  z-index: 9999; /* Higher z-index */
  animation: slideUpAndFade 0.2s ease-out;
}
.popover-content p, .popover-content ul > li {
  font-size: 12px;
  color: #000;
}

.popover-arrow {
  fill: #fff; /* Changed from #333 to white */
}

table {
  position: relative;
  z-index: 1;
}

details[open] summary span {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;yCAAA;AAGA;EACE,gCAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAEA;EACE,8BAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,0BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA;EACE,yBAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AALF;AAQA;EACE,iCAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAPF;AAUA;EACE,gCAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AATF;AAYA;EACE,8BAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAXF;AAcA;;yCAAA;AASA,iBAAA;AAQA;;yCAAA;AAkCA;;yCAAA;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,cAAA;AAxDF;;AA4DA;;;;;;;;;;;EAWE,cAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,iCAvJQ;EAwJR,cA/JS;AAsGX;;AA4DA;;EAEE,gBAAA;AAzDF;;AA4DA;;EAEE,YAAA;AAzDF;;AA4DA;;;;EAIE,WAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,iBAAA;AAzDF;;AA4DA;;yCAAA;AAGA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,cAAA;AAzDF;AA2DE;EAGE,cAAA;AA3DJ;;AA+DA;;;EAGE,kBAAA;AA5DF;;AA8DA;;;;EAIE,gBAAA;AA3DF;;AA8DA;EACE,WAAA;AA3DF;;AA6DA;EACE,YAAA;AA1DF;;AA6DA;;EAEE,WAAA;EACA,cAAA;EACA,WAAA;AA1DF;;AA6DA;EACE,aAAA;AA1DF;;AA6DA;;;;EAIE,gBAAA;EACA,gBAAA;AA1DF;;AA6DA;EACE,YAAA;AA1DF;;AA4DA;EACE,sBAAA;AAzDF;;AA2DA;;;EAGE,YAAA;AAxDF;;AA2DA,sBAAA;AACA;EACE,aAAA;AAxDF;AAzKI;EAgOJ;IAGI,cAAA;EAtDF;AACF;;AAyDA;EACE,aAAA;AAtDF;AA9KI;EAmOJ;IAGI,cAAA;EApDF;AACF;;AAuDA;EACE,aAAA;AApDF;AA/LI;EAkPJ;IAGI,cAAA;EAlDF;AACF;;AAqDA;;yCAAA;AAGA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAlDF;AAlNI;EAgQJ;IAQI,eAAA;IACA,kBAAA;IACA,mBAAA;EAlDF;AACF;AArNI;EA4PJ;IAeI,gBAAA;EAlDF;AACF;AAtNI;EAwPJ;IAoBI,gBAAA;EAlDF;AACF;AAvNI;EAoPJ;IAyBI,iBAAA;EAlDF;AACF;AAxNI;EAgPJ;IA8BI,iBAAA;EAlDF;AACF;;AAuDA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA,EAAA,4BAAA;EACA,mBAAA;AApDF;;AAsDA;EACE,SAAA;AAnDF;;AAsDA;;;;;EAKE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAnDF;AAoDE;EACE,6CAAA;AAlDJ;;AAsDA;;EAEE,gBAAA;EACA,mBAAA;AAnDF;;AAsDA,oDAAA;AACA;;EAEE,gBAAA;AAnDF;;AAsDA;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;AApDF;;AAuDA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AApDF;;AAuDA;EACE,WAAA;AApDF;;AAuDA;EACE,eAAA;EACA,WAAA;AApDF;;AAuDA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AApDF;;AAsDA;EACE,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,iBAAA;EAKA,kBAAA;AAvDF;AA9UI;EA2XJ;IAYI,oBAAA;EArDF;AACF;;AAwDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AArDF;AAsDE;EACE,YAAA;EACA,mBAAA;AApDJ;;AAuDA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;AApDF;AAsDE;EACE,WAAA;EACA,mBAAA,EAAA,2BAAA;EACA,sBAAA;AApDJ;AAuDE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;AArDJ;AAwDE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAtDJ;AAyDE;EACE,mBAAA;AAvDJ;;AA0DA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAvDF;AAwDE;EACE,mBAAA;EACA,eAAA;EACA,iCA3dM;AAqaV;;AAyDA;EACE,gBAAA;EACA,mBAAA;AAtDF;;AAwDA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,oBAAA;AAtDF;AAuDE;EACE,YAAA;AArDJ;AAuDE;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AArDJ;AAuDE;EACE,eAAA;EACA,iCA5fM;AAucV;AAuDE;EACE,gBAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAtDJ;AAwDE;EACE,eAAA;EACA,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAtDJ;AAwDE;EACE,uBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAtDJ;AAyDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAvDJ;AAyDE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvDJ;;AA0DA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAvDF;AAwDE;EACE,YAAA;AAtDJ;AAwDE;EACE,kBAAA;AAtDJ;AAwDE;EACE,iBAAA;EACA,eAAA;AAtDJ;AAwDE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAtDJ;;AAyDA;EACE,iBAAA;EACA,SAAA;EAEA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAvDF;;AA0DA,cAAA;AACA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvDF;AA/gBI;EA+jBJ;IASI,cAAA;EArDF;AACF;AAuDE;EACE,aAAA;EACA,gBAAA;AArDJ;AAxhBI;EA2kBF;IAII,gBAAA;EAnDJ;AACF;;AAsDA,cAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAnDF;;AAsDA,WAAA;AACA;;;;EAIE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,iCAxnBQ;AAqkBV;;AAsDA;EACE,qBAAA;AAnDF;;AAsDA,mBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;AAnDF;;AAsDA,gBAAA;AACA;EAEE,mBAAA;AApDF;;AAuDA;EACE,cAAA;EACA,gBAAA;EAEA,iCAjpBQ;AA4lBV;;AAwDA;EACE,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,eAAA;EACA,iBAAA;AAtDF;;AAyDA,iBAAA;AACA;EACE,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAtDF;;AAyDA;EACE,qBAAA;EACA,yBAAA;EACA,uBAAA;AAtDF;;AAyDA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,2DAAA;EACA,kBAAA;AAxDF;;AA0DA,mBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,SAAA;EACA,iCArsBQ;EAssBR,eAAA;EACA,uBAAA;AAvDF;;AA0DA,4BAAA;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAvDF;;AA0DA,8BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAvDF;;AA0DA,2BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAvDF;;AA0DA,4BAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;AAvDF;;AA0DA,gCAAA;AACA;EACE,UAAA;EACA,mBAAA;AAvDF;;AA0DA,gDAAA;AACA;EACE,mBAAA;EACA,qBAAA;AAvDF;;AA0DA,4CAAA;AACA;EACE,4CAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA,qBAAA;AACA;;EAEE,2DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCApxBQ;AA6tBV;;AA0DA;EACE,YAAA;EACA,mBAAA;AAvDF;;AA0DA;;EAEE,2DAAA;AAvDF;;AA0DA,iBAAA;AACA;EACE,kBAAA;EACA,aAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,eAAA;EACA,WAAA;AAvDF;;AA0DA,WAAA;AACA;EAIE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA1DF;AA4DE;EACE,YAAA;AA1DJ;AA6DE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AA3DJ;AA2CA;EAmBE,aAAA;AA3DF;AA4DE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA1DJ;AA4DE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA1DJ;AA4DE;;EAEE,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;AA1DJ;AA6DE;;EAEE,gBAAA;AA3DJ;AAWA;EAmDE,UAAA;AA3DF;AA4DE;EACE,WAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;AA3DJ;AA6DE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA,EAAA,kBAAA;EAIA,gBAAA;AA9DJ;AALA;EAsEE,qCAAA;AA9DF;AA+DE;EACE,kBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,6BAAA;AA7DJ;AA+DE;EACE,aAAA;AA7DJ;AAtBA;EAsFE,uCAAA;AA7DF;AA8DE;EACE,OAAA;EACA,MAAA;AA5DJ;AA8DE;EACE,qBAAA;EACA,MAAA;AA5DJ;AA8DE;EACE,OAAA;EACA,oBAAA;AA5DJ;AA8DE;EACE,qBAAA;EACA,oBAAA;AA5DJ;AAzCA;EAwGE,oBAAA;AA5DF;AA6DE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,oBAAA;AA3DJ;;AA+DA;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AA7DF;AA8DE;EACE,YAAA;AA5DJ;AA+DE;EACE,kBAAA;EACA,YAAA,EAAA,oBAAA;EACA,aAAA;EACA,6EAAA;EACA,oDAAA;AA7DJ;AA2CA;EAqBE,mCAAA;AA7DF;AA8DE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA,EAAA,+BAAA;EACA,UAAA;EACA,eAAA;AA5DJ;AA6DI;EACE,aAAA;EACA,gBAAA;AA3DN;AA6DI;EACE,aAAA;AA3DN;AA8DE;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,iCAl9BM;AAs5BV;AAkEE;EACE,YAAA;EACA,gBAAA;AAhEJ;;AAoEA;EACE,WAAA;EACA,aAAA;AAjEF;AAmEE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAjEJ;AAmEE;EACE,YAAA;EACA,gBAAA;AAjEJ;AAmEE;EACE,kFAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjEJ;AAoEE;EACE,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;AAlEJ;AAoEE;EACE,YAAA;AAlEJ;AAqEE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;AAnEJ;AAsEE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AApEJ;AAuEE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AArEJ;AAwEE;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAtEJ;AAyEE;EACE,oDAAA;EACA,WAAA;EACA,mBAAA;AAvEJ;AAyEE;EACE,SAAA;AAvEJ;AA0EE;EACE,YAAA;AAxEJ;AA0EE;EACE,YAAA;AAxEJ;AA2EE;EACE,aAAA;EACA,sBAAA;AAzEJ;AA4EE;EACE,aAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA1EJ;AA6EE;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AA3EJ;AA8EE;EACE,YAAA;EACA,mBAAA;AA5EJ;AA+EE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AA7EJ;AA+EE;EACE,kBAAA;AA7EJ;AA8EI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AA5EN;;AAiFA;EACE,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EAEA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AA/EF;AAiFE;EACE,gBAAA;EACA,cAAA;AA/EJ;AAkFE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAhFJ;AAmFE;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAjFJ;AAoFE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAlFJ;AAqFE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAnFJ;AAsFE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AApFJ;AAsFI;EACE,eAAA;EACA,8BAnpCC;AA+jCP;AAwFE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAtFJ;AAyFE;EACE,gBAAA;AAvFJ;AA0FE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAxFJ;AA0FI;EACE,qDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;AAxFN;AA2FI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,mBAAA;AA1FN;AA6FI;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;AA3FN;AA8FI;EACE,SAAA;AA5FN;AA+FI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AA7FN;AAgGI;EACE,eAAA;EAEA,eAAA;EACA,8BAptCC;EAqtCD,YAAA;AA/FN;AAkGI;EACE,UAAA;EACA,YAAA;EACA,0CAAA;AAhGN;AAoGE;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,+GAAA;EAMA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAvGJ;AA0GE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAxGJ;AA2GE;EACE,eAAA;EACA,eAAA;EACA,8BAzvCG;EA0vCH,YAAA;EACA,gBAAA;AAzGJ;AA4GE;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,2DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BA1wCG;AAgqCP;AA6GE;EACE,qBAAA;EACA,YAAA;AA3GJ;AA8GE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;AA5GJ;AA+GE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,8BA/xCG;EAgyCH,kBAAA;EACI,mBAAA;AA7GR;AAgHE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AA9GJ;AAiHE;;EAEE,YAAA;EACA,kBAAA;EACA,eAAA;AA/GJ;AAkHE;EACE,8BAlzCG;EAmzCH,eAAA;AAhHJ;;AAoHA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAjHF;AAmHE;EACE,mBAAA;EACA,iFAAA;EACA,yBAAA;EACA,mBAAA;AAjHJ;AAoHE;EAEE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAnHJ;AAoHI;EACE,SAAA;AAlHN;AAqHE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAnHJ;AAqHE;EAEE,iBAAA;EACA,eAAA;EACA,8BAt1CG;AAkuCP;AAsHE;EACE,eAAA;EACA,mBAAA;EAEA,mBAAA;EACA,mFAAA;EACA,iCAn2CM;AA8uCV;AAwHE;EACE,mBAAA;EACA,WAAA;AAtHJ;AAyHE;EACE,WAAA;EACA,yBAAA;EAEA,wCAAA;AAxHJ;AA2HE;;EAGE,aAAA;EACA,gBAAA;EACA,eAAA;AA1HJ;AA6HE;EAEE,eAAA;AA5HJ;AAoIA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EAEA,mBAAA;EACA,aAAA;EACA,kBAAA;AAnIF;AAoIE;EACE,cAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;AAlIJ;AAqIE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAnIJ;AAqIE;EACE,iBAAA;AAnIJ;AAsIE;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;AApIJ;AAuIE;EACE,2DAAA;EAEA,YAAA;AAtIJ;AAyIE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAvIJ;AAyII;EACE,8BAp7CC;EAq7CD,eAAA;EACA,yBAAA;AAvIN;AA0II;EACE,kBAAA;AAxIN;AA6IQ;EACE,kBAAA;AA3IV;AA+IQ;EACE,kBAAA;AA7IV;AAmJE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAjJJ;AAoJE;;EAEE,YAAA;EACA,gBAAA;AAlJJ;AA0JE;EACE,mBAAA;AAxJJ;;AA6JE;EACE,aAAA;EACA,iCAz+CM;EA0+CN,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AA1JJ;AA2JI;EACE,YAAA;AAzJN;;AA8JA;EACE,aAAA;AA3JF;;AA8JA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AA3JF;;AA8JA;EACE,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,oDAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;AA3JF;AA8JE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AA5JJ;AA+JE;EACE,mBAAA;AA7JJ;AAgKE;EACE,mBAAA;EACA,WAAA;AA9JJ;;AAkKA;EACE,aAAA;EACA,qBAAA;EACA,2CAAA;AA/JF;;AAkKA;EACE,YAAA;AA/JF;;AAkKA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,WAAA;AA/JF;AAiKE;EACE,eAAA;AA/JJ;;AAmKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AAhKF;;AAmKA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wCAAA;EACA,yBAAA;EACA,4BAAA;AAjKF;;AAoKA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjKF;;AAoKA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjKF;;AAoKA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAjKF;;AAoKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjKF;;AAoKA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAjKF;AAmKE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjKJ;;AAqKA;EACE,2DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAlKF;AAmKE;EACE,qBAAA;EACA,YAAA;AAjKJ;;AAqKA;EACE,eAAA;EACA,iBAAA;AAlKF;;AAqKA;EACE,kBAAA;EACA,WAAA;AAlKF;;AAqKA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;AAlKF;;AAqKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,wCAAA;AAlKF;;AAqKA;EACE,qBAAA;EACA,wCAAA;AAlKF;;AAqKA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,UAAA;EACA,2CAAA;AAlKF;;AAqKA,2BAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;AAlKF;;AAqKA;EACE,gBAAA;EACA,eAAA;AAlKF;;AAqKA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iCAjuDQ;AA+jDV;;AAqKA;EACE,kBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,gBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,8BA7uDK;AA2kDP;;AAqKA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAlKF;;AAqKA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAlKF;;AAqKA;EACE,gBAAA;EACA,kBAAA;EACA,4BAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAlKF;;AAqKA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;AAlKF;;AAqKA;EACE,cAAA;EACA,0BAAA;AAlKF;;AAqKA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;AAlKF;;AAqKA;EACE,2BAAA;EACA,+CAAA;AAlKF;;AAqKA;EACE,wBAAA;AAlKF;;AAqKA,sBAAA;AACA;EACE;IACE,aAAA;EAlKF;EAqKA;IACE,kBAAA;EAnKF;EAsKA;IACE,eAAA;EApKF;EAuKA;IACE,eAAA;IACA,kBAAA;EArKF;EAwKA;IACE,eAAA;EAtKF;EAyKA;IACE,kBAAA;IACA,eAAA;EAvKF;AACF;AAyKA;EACE,eAAA;AAvKF;;AA0KA;EACE,0BAAA;EACA,8BA72DK;AAssDP;;AA0KA;EACE,gBAAA;EACA,mBAAA;AAvKF;;AAmLA;EACE,iBAAA;EACA,6DAAA;EACA,aAAA;AAhLF;AAkLE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAfQ;EAgBR,2CAAA;AAhLJ;AAmLE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAjLJ;AAoLE;;EAEE,2DAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAt6DM;AAovDV;AAqLE;EACE,YAAA;EACA,mBAAA;AAnLJ;AAsLE;;EAEE,2DAAA;AApLJ;AAuLE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBA3DI;EA4DJ,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cA9DQ;EA+DR,mBAAA;EACA,yBAAA;EACA,wCAAA;AArLJ;AAuLI;EACE,mBAvEO;EAwEP,cAtEE;EAuEF,4CAAA;AArLN;AAwLI;EACE,mBAAA;EACA,2BAAA;EACA,0CAAA;AAtLN;AA0LE;EACE,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAxLJ;AA2LE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA7FQ;EA8FR,mBAAA;EACA,oBAAA;EACA,iDAAA;AAzLJ;AA4LE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;AA1LJ;AA6LE;EACE,aAAA;EACA,sBAAA;AA3LJ;AA8LE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAxHQ;AApEZ;AA+LE;EACE,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAlII;EAmIJ,cAlIQ;AA3DZ;AA+LI;EACE,aAAA;EACA,qBAzIO;EA0IP,2CAAA;AA7LN;AAgMI;EACE,cAzIO;AArDb;AAkME;EACE,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,mBArJI;EAsJJ,cArJQ;AA3CZ;AAkMI;EACE,aAAA;EACA,qBA5JO;EA6JP,2CAAA;AAhMN;AAoME;EACE,kBAAA;EACA,mBAnKS;EAoKT,cAlKI;EAmKJ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,2CAAA;AAlMJ;AAoMI;EACE,mBA7KQ;EA8KR,2BAAA;EACA,4CAAA;AAlMN;AAqMI;EACE,wBAAA;AAnMN;AAuME;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;AArMJ;AAwME;EACE,WAAA;EACA,yBAAA;EACA,mBAhMI;AANR;AAyME;EACE,6DAAA;AAvMJ;AA0ME;EACE,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,cA3MQ;EA4MR,eAAA;EACA,yBAAA;EACA,qBAAA;AAxMJ;AA2ME;EACE,iDAAA;EACA,yBAAA;AAzMJ;AA2MI;EACE,qCAAA;AAzMN;AA4MI;EACE,mBAAA;AA1MN;AA8ME;EACE,kBAAA;EACA,cA/NU;EAgOV,eAAA;AA5MJ;AA+ME;EACE,kBAAA;EACA,kBAAA;EACA,cArOS;EAsOT,kBAAA;EACA,eAAA;AA7MJ;AAgNE;EACE,kBAAA;EACA,kBAAA;EACA,cA/OQ;EAgPR,eAAA;EACA,gBAAA;AA9MJ;AAiNE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;AA/MJ;AAkNE;EACE,eAAA;EACA,cAjQQ;EAkQR,gBAAA;AAhNJ;AAmNE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAjNJ;AAoNE;EACE,kBAAA;EACA,0CAAA;EACA,mBA/QI;EAgRJ,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAnRQ;EAoRR,yBAAA;AAlNJ;AAoNI;EACE,mBA1RO;EA2RP,cAzRE;EA0RF,qBA5RO;EA6RP,2BAAA;EACA,2CAAA;AAlNN;AAqNI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAhSO;EAiSP,qBAAA;AAnNN;AAuNE;EACE,kBAAA;EACA,eAAA;EACA,cA1SQ;EA2SR,gBAAA;EACA,oCAAA;EACA,kBAAA;AArNJ;AAwNE;EACE,mBAAA;EACA,aAAA;EACA,gCAAA;AAtNJ;AAuNI;EACE,oBAAA;AArNN;AAwNI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;EACA,oBAAA;AAtNN;AAyNI;EACE,cAAA;EACA,4BAAA;AAvNN;AA0NI;EACE,cAAA;EACA,4BAAA;EACA,8BAlsEC;AA0+DP;;AA8NA;EACE;IACE,aAAA;EA3NF;EA6NE;IACE,sBAAA;IACA,SAAA;EA3NJ;EA8NE;IACE,eAAA;EA5NJ;EA+NE;IACE,kBAAA;EA7NJ;EAgOE;IACE,sBAAA;IACA,oBAAA;EA9NJ;EAiOE;IACE,WAAA;EA/NJ;EAkOE;IACE,sBAAA;IACA,kBAAA;EAhOJ;AACF;AAoOA;EACE,2DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;AAlOF;AAmOE;EACE,2DAAA;EACA,YAAA;AAjOJ;;AAqOA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAlOF;;AAqOA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;AAlOF;AAoOE;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAlOJ;AAoOI;EARF;IASI,aAAA;EAjOJ;AACF;AAmOI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAjON;AAmOM;EARF;IASI,eAAA;EAhON;AACF;AAmOI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAjON;AAoOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAlON;AAqOI;EACE,mBAAA;AAnON;AAqOM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAnOR;AAqOQ;EAPF;IAQI,eAAA;EAlOR;AACF;AAqOM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAnOR;AAsOM;EACE,iBAAA;EACA,mBAAA;AApOR;AAsOQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AApOV;AAwOM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAtOR;AAwOQ;EACE,0BAAA;AAtOV;AA0OM;EACE,mBAAA;AAxOR;AA0OQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAxOV;AA4OM;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AA1OR;AA4OQ;EACE,mBAAA;AA1OV;AA4OU;EACE,gBAAA;AA1OZ;AAgPI;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA9ON;AAgPM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA9OR;AAgPQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;AA9OV;AAiPQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;AA/OV;;AAsPA;EACE,gBAAA;EACA,kBAAA;AAnPF;AAqPE;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAnPJ;AAqPI;EACE,8BAp6EC;EAq6ED,YAAA;AAnPN;AAuPE;EAGE,gBAAA;AAvPJ;AAyPI;EACE,YAAA;EACA,mBAAA;AAvPN;;AA4PA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAzPF;AA2PE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAzPJ;AA4PE;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA1PJ;AA4PI;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;AA1PN;AA8PE;EACE,iBAAA;AA5PJ;;AAiQE;EACE,8BAz9EG;AA2tEP;AAgQE;EACE,wBAAA;AA9PJ;;AAkQA;EACE,gBAAA;AA/PF;AAiQE;EACE,gBAAA;AA/PJ;;AAqQA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAlQF;AAoQE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;AAlQJ;AAqQE;EACE,mBAAA;EACA,eAAA;EACA,WAAA;AAnQJ;AAsQE;EACE,mBAAA;EACA,eAAA;EACA,WAAA;AApQJ;AAuQE;EACE,aAAA;EACA,sBAAA;AArQJ;AAwQE;EACE,oCAAA;AAtQJ;AAyQE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;AAvQJ;AAyQI;EACE,aAAA;AAvQN;AA0QI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAxQN;AA2QI;EACE,WAAA;AAzQN;AA6QE;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AA3QJ;AA8QE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AA5QJ;AA+QE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AA7QJ;AA+QI;EACE,mBAAA;EACA,YAAA;AA7QN;AAgRI;EACE,YAAA;EAEA,gBAAA;AA/QN;AAiRM;EACE,gBAAA;AA/QR;AAkRM;EACE,YAAA;AAhRR;AAoRI;EACE,YAAA;EACA,YAAA;AAlRN;AAoRM;EACE,4CAAA;AAlRR;AAqRM;EACE,sBAAA;AAnRR;;AA0RA;EACE;IAEE,wBAAA;EAxRF;EA0RA;IACE,2BAAA;EAxRF;EA0RA;IACE,0BAAA;EAxRF;AACF;AA4RA;EAEI;IACE,aAAA;IACA,UAAA;EA3RJ;EA8RE;IACE,eAAA;EA5RJ;EA+RE;IACE,eAAA;EA7RJ;EAgSE;IACE,kBAAA;IACA,eAAA;EA9RJ;AACF;AAkSA;EACE,iBAAA;AAhSF;;AAoSA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,aAAA,EAAA,mBAAA;EACA,uCAAA;AAjSF;AAmSE;EACE,eAAA;EACA,WAAA;AAjSJ;;AAqSA;EACE,UAAA,EAAA,+BAAA;AAlSF;;AAqSA;EACE,kBAAA;EACA,UAAA;AAlSF;;AAqSA;EACE,yBAAA;AAlSF","sourcesContent":["/* --------------------------------------\n   Fonts\n--------------------------------------- */\n@font-face {\n  font-family: \"Montserrat italic\";\n  src: url(\"../fonts/Montserrat-ThinItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-ThinItalic.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat thin\";\n  src: url(\"../fonts/Montserrat-Thin.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Thin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Exo Regular\";\n  src: url(\"../fonts/Exo2-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Exo2-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Exo italic\";\n  src: url(\"../fonts/Exo2-Italic.woff2\") format(\"woff2\"),\n    url(\"../fonts/Exo2-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat-Regular\";\n  src: url(\"../fonts/Montserrat-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat-Medium\";\n  src: url(\"../fonts/Montserrat-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat-Bold\";\n  src: url(\"../fonts/Montserrat-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* --------------------------------------\n   Variables\n--------------------------------------- */\n$darkBlue: #11173e;\n$lightBlue: #1271f3;\n$green: #72f300;\n\n$vh: 6.25px;\n\n/* Font aliases */\n$regular: \"Montserrat-Regular\";\n$Italic: \"Exo italic\";\n$mthin: \"Montserrat thin\";\n$mitalic: \"Montserrat italic\";\n$medium: \"Montserrat-Medium\";\n$bold: \"Montserrat-Bold\";\n\n/* --------------------------------------\n   Mixins\n--------------------------------------- */\n\n// Responsive breakpoints (Bootstrap/Tailwind standard)\n@mixin mq($size) {\n  @if $size == xs {\n    @media (max-width: 575px) {\n      @content;\n    }\n  } @else if $size == mobile {\n    @media (max-width: 767px) {\n      @content;\n    } // for all phones\n  } @else if $size == tab {\n    @media (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size == desktop {\n    @media (min-width: 1025px) and (max-width: 1399px) {\n      @content;\n    }\n  } @else if $size == large {\n    @media (min-width: 1400px) {\n      @content;\n    }\n  }\n}\n\n// Modern flexbox\n@mixin flexbox {\n  display: flex;\n}\n\n/* --------------------------------------\n   Reset CSS (Meyer reset + tweaks)\n--------------------------------------- */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  color: inherit;\n}\n\n// HTML5 elements display block\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1.5;\n  font-family: $regular;\n  color: $darkBlue;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: \"\";\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* --------------------------------------\n   Global Helpers\n--------------------------------------- */\n* {\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: inherit;\n  }\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\nb,\nstrong,\nth,\n.bold-text {\n  font-weight: 700;\n}\n\n.left {\n  float: left;\n}\n.right {\n  float: right;\n}\n\n.clearfix::after,\n.wrap-clear::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  border-radius: 0;\n  appearance: none;\n}\n\ntextarea {\n  resize: none;\n}\n* {\n  box-sizing: border-box;\n}\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\n/* Show/hide helpers */\n.tablet {\n  display: none;\n  @include mq(tab) {\n    display: block;\n  }\n}\n\n.desktop {\n  display: none;\n  @include mq(desktop) {\n    display: block;\n  }\n}\n\n.mobile {\n  display: none;\n  @include mq(mobile) {\n    display: block;\n  }\n}\n\n/* --------------------------------------\n   Layout\n--------------------------------------- */\n.container {\n  width: 100%;\n  margin: 0 auto;\n  padding-left: 16px;\n  padding-right: 16px; // default gutter for mobile-first\n\n  // Extra small (phones <576px)\n  @include mq(xs) {\n    max-width: 100%;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  // Small devices (≥576px)\n  @include mq(mobile) {\n    max-width: 540px;\n  }\n\n  // Medium devices (≥768px)\n  @include mq(tab) {\n    max-width: 720px;\n  }\n\n  // Large devices (≥1025px)\n  @include mq(desktop) {\n    max-width: 1140px;\n  }\n\n  // Extra large devices (≥1400px)\n  @include mq(large) {\n    max-width: 1320px;\n  }\n}\n\n// /////////////\n\n.screen {\n  max-width: 400px;\n  margin: 40px auto;\n  padding: 20px;\n  text-align: center;\n  font-family: Arial, sans-serif;\n  background: #f8e287; /* light golden background */\n  border-radius: 12px;\n}\ninput[type=\"radio\" i] {\n  margin: 0;\n}\n\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"password\"],\ninput[type=\"tel\"],\ninput[type=\"email\"] {\n  display: block;\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border-radius: 25px;\n  border: none;\n  outline: none;\n  text-align: center;\n  font-size: 16px;\n}\n\nbutton {\n  width: 100%;\n  padding: 14px;\n  margin-top: 12px;\n  border: none;\n  border-radius: 25px;\n  background: linear-gradient(#0e800f, #045504);\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  &:hover {\n    background: linear-gradient(#0c660c, #034603);\n  }\n}\n\nbutton:disabled,\nbutton[disabled] {\n  background: gray;\n  cursor: not-allowed;\n}\n\n/* Prevent hover color change for disabled buttons */\nbutton:disabled:hover,\nbutton[disabled]:hover {\n  background: gray;\n}\n\nlabel {\n  display: block;\n  // margin: 5px 0;\n  font-size: 10px;\n  text-align: left;\n}\n\n.radio-group {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 5px;\n}\n\nh2 {\n  color: #222;\n}\n\np {\n  font-size: 14px;\n  color: #333;\n}\n\n.back-btn {\n  width: auto;\n  padding: 8px 16px;\n  margin-top: 12px;\n  border-radius: 20px;\n  background: black;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n}\n.main-bg {\n  background-image: url(\"../images/Bg.png\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  // display: flex;\n  // justify-content: center;\n  // align-items: center;\n  // flex-direction: column;\n  padding-top: 120px;\n  @include mq(mobile) {\n    padding-bottom: 55px;\n  }\n}\n\n.home-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 20px;\n  img {\n    width: 250px;\n    margin-bottom: 20px;\n  }\n}\n.input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  z-index: 1;\n\n  input {\n    width: 100%;\n    padding-right: 30px; /* space for tooltip icon */\n    box-sizing: border-box;\n  }\n\n  .tooltip {\n    position: absolute;\n    right: 8px;\n    top: 40%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    font-weight: bold;\n    color: #666666d3;\n  }\n\n  .tooltiptext {\n    visibility: hidden;\n    width: 160px;\n    background: #333;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    border-radius: 4px;\n    position: absolute;\n    top: -40px;\n    right: 0;\n    z-index: 1;\n    font-size: 12px;\n  }\n\n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n  }\n}\n.flex-common {\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 50px;\n  h2 {\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-family: $regular;\n  }\n}\n.logo-main {\n  max-width: 240px;\n  margin-bottom: 20px;\n}\n.instructions-wrapper {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-position-x: left;\n  background-size: 60%;\n  .logo-main {\n    width: 250px;\n  }\n  .wrapper {\n    padding: 0 40px;\n    padding-top: 100px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    text-align: center;\n    gap: 50px;\n  }\n  h2 {\n    font-size: 30px;\n    font-family: $regular;\n  }\n  p {\n    margin-top: 10px;\n    font-size: 15px;\n\n    line-height: 1.3;\n    max-width: 250px;\n    text-align: center;\n  }\n  .fifty-six {\n    font-size: 50px;\n    border: 1px solid rgba(43, 42, 42, 0.412);\n    border-radius: 50%;\n    padding: 10px;\n    width: 82px;\n    height: 82px;\n    display: flex;\n    align-items: center;\n  }\n  .btn-next {\n    background: transparent;\n    padding: 0;\n    color: black;\n    font-weight: bold;\n  }\n\n  .circle-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    font-size: 15px;\n    margin-top: 10px;\n  }\n  .circle-right {\n    margin-left: -18px;\n    line-height: 1.1;\n    background: #d2ac48;\n  }\n}\n.win-wrapper {\n  padding: 0 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  .win-img {\n    width: 300px;\n  }\n  button {\n    width: max-content;\n  }\n  h2 {\n    font-weight: bold;\n    font-size: 30px;\n  }\n  p {\n    text-align: center;\n    font-size: 18px;\n    line-height: 1.3;\n  }\n}\n.back-btn {\n  background: black;\n  border: 0;\n\n  max-width: fit-content;\n  font-size: 12px;\n  border-radius: 20px;\n  padding: 3px 5px;\n}\n\n/* Container */\n.form-container {\n  max-width: 420px;\n  margin: 40px auto;\n  padding: 20px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  font-family: \"Arial\", sans-serif;\n}\n\n.footer-line {\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  text-align: center;\n  font-size: 10px;\n  margin-top: 50px;\n  padding: 12px 8px;\n  @include mq(mobile) {\n    font-size: 8px;\n  }\n\n  .bottom-footer-line {\n    margin-top: 0;\n    margin-top: 10px;\n    @include mq(mobile) {\n      margin-top: 10px;\n    }\n  }\n}\n/* Form Card */\n.form-card {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n/* Inputs */\n.form-card input[type=\"text\"],\n.form-card input[type=\"number\"],\n.form-card input[type=\"tel\"],\n.form-card input[type=\"password\"] {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  font-family: $regular;\n}\n\n.form-card input:focus {\n  border-color: #28a745;\n}\n\n/* Error messages */\n.error {\n  font-size: 13px;\n  color: #b30000;\n  margin: -10px 0 8px 4px;\n  text-align: center;\n}\n\n/* Radio group */\n.radio-group {\n  // margin: 12px 0;\n  margin-bottom: 10px;\n}\n\n.radio-label {\n  display: block;\n  font-weight: 600;\n  // margin-bottom: 6px;\n  font-family: $regular;\n}\n\n.radio-group label {\n  display: flex;\n  align-items: center;\n  // margin-right: 20px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Custom radio */\n.radio-group input[type=\"radio\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #000000;\n  background: white;\n  border-radius: 50%;\n  margin-right: 8px;\n  cursor: pointer;\n  position: relative;\n}\n\n.radio-group input[type=\"radio\"]:checked {\n  border-color: #28a745;\n  background-color: #28a745;\n  border: 1px solid black;\n}\n\n.radio-group input[type=\"radio\"]:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  // width: 8px;\n  // height: 8px;\n  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n  border-radius: 50%;\n}\n/* Checkbox group */\n.checkbox-group {\n  font-size: 14px;\n  line-height: 1.4;\n  margin-bottom: 10px;\n}\n\n.flex-label {\n  display: flex;\n  gap: 10px;\n  font-family: $regular;\n  cursor: pointer;\n  align-items: flex-start;\n}\n\n/* Custom checkbox wrapper */\n.custom-checkbox-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* Hide the default checkbox */\n.custom-checkbox-wrapper input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n}\n\n/* Custom checkbox design */\n.custom-checkbox {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #000;\n  border-radius: 50%;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n/* Checkmark using ::after */\n.custom-checkbox::after {\n  content: \"✓\";\n  font-size: 14px;\n  font-weight: bold;\n  color: #28a745;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.2s ease;\n}\n\n/* Show checkmark when checked */\n.custom-checkbox-wrapper input[type=\"checkbox\"]:checked + .custom-checkbox::after {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Optional: Add background color when checked */\n.custom-checkbox-wrapper input[type=\"checkbox\"]:checked + .custom-checkbox {\n  background: #f0f9f4;\n  border-color: #28a745;\n}\n\n/* Optional: Focus state for accessibility */\n.custom-checkbox-wrapper input[type=\"checkbox\"]:focus + .custom-checkbox {\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);\n}\n\n.checkbox-text {\n  line-height: 1.5;\n}\n\n/* Submit / Buttons */\n.submit-btn,\nbutton {\n  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n  color: #fff;\n  border: none;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 12px;\n  transition: background 0.3s ease;\n  font-family: $regular;\n}\n\n.submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.submit-btn:hover,\nbutton:hover {\n  background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);\n}\n\n/* Instructions */\n.instruction-step {\n  text-align: center;\n  padding: 20px;\n}\n\n.instruction-step h2 {\n  margin-bottom: 12px;\n  font-size: 20px;\n}\n\n.instruction-step p {\n  margin-bottom: 20px;\n  font-size: 15px;\n  color: #444;\n}\n\n/* Layout */\n.page {\n  // min-height: 100vh;\n  // background: #f7f8fb;\n  // padding: 16px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  /* Layout */\n\n  .logo-img {\n    width: 300px;\n  }\n\n  .wrap {\n    width: 100%;\n    max-width: 480px;\n    margin: 0 auto;\n  }\n\n  /* Controls */\n  .controls {\n    display: flex;\n    gap: 8px;\n    margin: 12px 0 16px;\n    justify-content: center;\n    flex-direction: column;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n  }\n  .wrapper-btn {\n    display: flex;\n    gap: 8px;\n    margin: 12px 0 16px;\n    justify-content: center;\n    align-items: center;\n  }\n  .btn,\n  .filebtn {\n    padding: 8px 12px;\n    border: 1px solid #cbd5e1;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n\n  .shuffle-btn,\n  .reset-btn {\n    max-width: 120px;\n  }\n\n  /* Board */\n  .board-outer {\n    width: 100%;\n    // max-width: 280px; /* tweak size as you like */\n    margin: 0 auto;\n    padding: 0 10px;\n    max-width: 340px;\n  }\n  .board {\n    /* square board */\n    position: relative;\n    width: 100%;\n    padding-top: 100%; /* aspect-square */\n\n    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\n    overflow: hidden;\n  }\n\n  /* 2x2 grid using absolute children */\n  .tile {\n    position: absolute;\n    width: calc(50% - 1px); /* 2px gap total => 1px each side */\n    height: calc(50% - 1px);\n    background-size: 200% 200%;\n    background-repeat: no-repeat;\n    user-select: none;\n    touch-action: none;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) inset;\n    border: 1px solid transparent;\n  }\n  .tile.dragging {\n    opacity: 0.85;\n  }\n\n  /* place tiles in a 2x2 with 2px gaps */\n  .slot-0 {\n    left: 0;\n    top: 0;\n  }\n  .slot-1 {\n    left: calc(50% + 1px);\n    top: 0;\n  }\n  .slot-2 {\n    left: 0;\n    top: calc(50% + 1px);\n  }\n  .slot-3 {\n    left: calc(50% + 1px);\n    top: calc(50% + 1px);\n  }\n\n  /* the subtle ring */\n  .tile::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    pointer-events: none;\n  }\n}\n\n.result-block {\n  padding: 0 40px;\n  //min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  gap: 5px;\n  .main-logo {\n    width: 250px;\n  }\n\n  .poster {\n    position: relative;\n    width: 200px; /* अपनी इमेज जितना */\n    height: 150px;\n    background: url(\"../images/greenbg.png\") no-repeat center/contain;\n    /* no-repeat और cover से पूरी div पर इमेज फिट होगी */\n  }\n\n  /* टेक्स्ट को बीच में लाने के लिए */\n  .overlay-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: #fff; /* इमेज के हिसाब से रंग चुनें */\n    width: 70%;\n    font-size: 12px;\n    p {\n      color: yellow;\n      line-height: 1.3;\n    }\n    a {\n      color: yellow;\n    }\n  }\n  h2 {\n    font-size: 30px;\n    text-transform: uppercase;\n    line-height: 1.3;\n    color: #056a35;\n    text-shadow: #ffe200 1px 1px;\n    font-family: $regular;\n  }\n\n  .overlay-text p {\n  }\n\n  .win-img {\n    width: 180px;\n    margin-top: 20px;\n  }\n}\n\n.form-container-ret {\n  width: 100%;\n  padding: 20px;\n\n  .wrapper-form {\n    padding: 0 20px;\n    position: relative;\n    max-width: 480px;\n    margin: 0 auto;\n  }\n  .logo-main {\n    width: 250px;\n    margin-top: 30px;\n  }\n  .page {\n    background: url(\"../images/Bg.png\") no-repeat center center/cover;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container {\n    width: 350px;\n    background: rgba(255, 215, 130, 0.92);\n    border-radius: 12px;\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);\n    text-align: center;\n    padding: 30px 20px;\n  }\n  .test {\n    color: black;\n  }\n\n  .logo {\n    font-size: 32px;\n    font-weight: bold;\n    color: #064f24;\n    margin: 0;\n    font-family: cursive;\n  }\n\n  .subtitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 5px 0 20px;\n    color: #222;\n  }\n\n  .tabs {\n    display: flex;\n    background: #fff;\n    border-radius: 25px;\n    overflow: hidden;\n    padding: 5px;\n    margin-bottom: 10px;\n  }\n\n  .tabs button {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    background: transparent;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .tabs button.active {\n    background: linear-gradient(90deg, #c8a74c, #e3c97a);\n    color: #fff;\n    border-radius: 25px;\n  }\n  button {\n    margin: 0;\n  }\n\n  .login {\n    color: black;\n  }\n  .test {\n    color: black;\n  }\n\n  form {\n    display: flex;\n    flex-direction: column;\n  }\n\n  input {\n    margin: 8px 0;\n    padding: 12px;\n    border: none;\n    border-radius: 25px;\n    outline: none;\n    font-size: 14px;\n  }\n\n  .verifyBtn {\n    margin-top: 10px;\n    padding: 12px;\n    border: none;\n    border-radius: 25px;\n    background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n    color: #fff;\n    font-weight: bold;\n    cursor: pointer;\n  }\n\n  .verifyBtn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .error {\n    margin-top: 10px;\n    font-size: 13px;\n    color: #b30000;\n  }\n  &.success-screen {\n    text-align: center;\n    .retailer-code {\n      color: black;\n      font-weight: bold;\n      font-size: 60px;\n    }\n  }\n}\n\n.dashboard-container {\n  background-image: url(\"../images/Bg.png\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  margin: 0 auto;\n  text-align: center;\n\n  border-radius: 12px;\n  padding: 20px;\n  padding-top: 100px;\n  padding-bottom: 80px;\n\n  .content-wrap {\n    max-width: 480px;\n    margin: 0 auto;\n  }\n\n  .retailer-wrapper {\n    background-color: #e9d5a3;\n    padding: 20px;\n    border-radius: 15px;\n    margin-top: 20px;\n  }\n\n  .loader {\n    margin: 40px auto;\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n  }\n\n  .logo-main {\n    max-width: 240px;\n    margin-bottom: 20px;\n    margin-top: 30px;\n  }\n\n  .subtitle {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    letter-spacing: 2px;\n  }\n\n  .retailer-info {\n    border-radius: 10px;\n    margin-bottom: 20px;\n    font-size: 12px;\n    text-align: left;\n    position: relative;\n    background: #efe2bf;\n    padding: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n    h1 {\n      font-size: 18px;\n      font-family: $bold;\n    }\n  }\n\n  .logoutBtn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    margin: 0;\n    background: #000;\n    color: #fff;\n    border: none;\n    border-radius: 20px;\n    padding: 6px 14px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: 0.3s;\n    width: max-content;\n  }\n\n  .logoutBtn:hover {\n    background: #333;\n  }\n\n  .stats {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n\n    .rank-card {\n      background: linear-gradient(135deg, #e0ad3a, #a66b00);\n      color: white;\n      border-radius: 16px;\n      text-align: center;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    }\n\n    .rank-title {\n      font-size: 12px;\n      font-weight: bold;\n      margin-bottom: 5px;\n\n      letter-spacing: 1px;\n    }\n\n    .rank-values {\n      display: flex;\n      justify-content: space-around;\n      align-items: center;\n    }\n\n    .rank-section {\n      flex: 1;\n    }\n\n    .rank-label {\n      font-size: 12px;\n      font-weight: 600;\n      opacity: 0.8;\n    }\n\n    .rank-number {\n      font-size: 22px;\n\n      margin-top: 4px;\n      font-family: $bold;\n      color: white;\n    }\n\n    .divider {\n      width: 1px;\n      height: 40px;\n      background-color: rgba(255, 255, 255, 0.4);\n    }\n  }\n\n  .card {\n    flex: 1;\n    background: white;\n    background: #ba8a0d;\n    background: linear-gradient(\n      111deg,\n      rgba(186, 138, 13, 1) 0%,\n      rgba(201, 156, 39, 0.87) 85%,\n      rgba(186, 138, 13, 1) 100%\n    );\n    padding: 7px;\n    border-radius: 10px;\n    text-align: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .card p {\n    font-size: 12px;\n    color: #444;\n    text-align: center;\n    color: white;\n  }\n\n  .card h3 {\n    margin: 5px 0 0;\n    font-size: 24px;\n    font-family: $bold;\n    color: white;\n    line-height: 1.4;\n  }\n\n  .cashbackBtn {\n    max-width: max-content;\n    padding: 12px 50px;\n    margin: 20px 0;\n    background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n    color: white;\n    border: none;\n    border-radius: 15px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: 0.3s;\n    font-family: $bold;\n  }\n\n  .cashbackBtn:hover {\n    background: darkgreen;\n    color: white;\n  }\n\n  .leaderboard {\n    background: #be9426;\n    padding: 10px;\n    border-radius: 10px;\n    color: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    border: 2px solid #efe2bf;\n  }\n\n  .leaderboard h2 {\n    font-size: 24px;\n    text-align: left;\n    color: white;\n    font-family: $bold;\n    text-align: center;\n        margin-bottom: 15px;\n  }\n\n  .leaderboard table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n  }\n\n  .leaderboard th,\n  .leaderboard td {\n    padding: 8px;\n    text-align: center;\n    font-size: 16px;\n  }\n\n  .leaderboard th {\n    font-family: $bold;\n    font-size: 16px;\n  }\n}\n\n.admin-dashboard {\n  padding: 20px;\n  background: #f8f8f8;\n  min-height: 100vh;\n\n  .bg-main-table {\n    background: #ae8a28;\n    background: linear-gradient(130deg, rgba(174, 138, 40, 1) 0%, rgba(200, 153, 39, 1) 100%);\n    border: 2px solid #ecddaf;\n    border-radius: 10px;\n  }\n\n  .total-entries {\n    //\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n    font-weight: bold;\n    .title-retailers {\n      flex: 1;\n    }\n  }\n  .wrapper-top-titles {\n    display: grid;\n    grid-template-columns: repeat(3, 3fr);\n    gap: 20px;\n  }\n  .white-box {\n    // background-color: white;\n    padding: 5px 10px;\n    font-size: 18px;\n    font-family: $bold;\n  }\n  .title-retailers {\n    padding: 20px 0;\n    border-radius: 10px;\n    // font-size: 13px;\n    background: #f3ecd4;\n    background: linear-gradient(130deg, rgba(243, 236, 212, 1) 0%, rgba(234, 220, 171, 1) 100%);\n    font-family: $regular;\n  }\n\n  .admin-dashboard h1 {\n    margin-bottom: 20px;\n    color: #333;\n  }\n\n  .admin-table {\n    width: 100%;\n    border-collapse: collapse;\n    // background: #fff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .admin-table th,\n  .admin-table td {\n    // border: 1px solid #ddd;\n    padding: 12px;\n    text-align: left;\n    font-size: 14px;\n  }\n\n  .admin-table th {\n    // background: white;\n    font-size: 16px;\n  }\n\n  .admin-table tr:nth-child(even) {\n    // background: #f2f2f2;\n  }\n}\n\n.congrats-page {\n  max-width: 100%;\n  width: 100%;\n  margin: 20px auto;\n\n  border-radius: 12px;\n  padding: 20px;\n  text-align: center;\n  h2 {\n    color: #0b6535;\n    font-size: 30px;\n    text-shadow: yellow 1px 1px;\n    font-weight: bold;\n  }\n\n  .tabs {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n  }\n  p {\n    font-weight: bold;\n  }\n\n  .tabs button {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    background: white;\n    cursor: pointer;\n    font-weight: bold;\n    color: black;\n    margin: 0;\n  }\n\n  .tabs button.active {\n    background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n\n    color: white;\n  }\n\n  .entries-table {\n    background: #be9426;\n    padding: 10px;\n    border-radius: 10px;\n    color: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    border: 2px solid #efe2bf;\n    max-width: 1200px;\n    margin: 0 auto;\n    margin-top: 10px;\n\n    h3 {\n      font-family: $bold;\n      font-size: 22px;\n      text-transform: uppercase;\n    }\n\n    .table-content {\n      overflow-x: scroll;\n    }\n\n    table {\n      thead {\n        tr th {\n          text-align: center;\n        }\n      }\n      tbody {\n        tr td {\n          text-align: center;\n        }\n      }\n    }\n  }\n\n  .entries-table table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n  }\n\n  .entries-table th,\n  .entries-table td {\n    padding: 8px;\n    text-align: left;\n  }\n\n  .entries-table tr,\n  .entries-table th {\n    // border-bottom: 1px solid #ddd;\n  }\n\n  .entries-table tr:last-child {\n    border-bottom: none;\n  }\n}\n\n.backBtn-wrapper {\n  .backBtn {\n    display: flex;\n    font-family: $regular;\n    margin-bottom: 20px;\n    align-items: center;\n    background-color: black;\n    color: white;\n    max-width: max-content;\n    padding: 5px 10px;\n    border-radius: 50px;\n    p {\n      color: white;\n    }\n  }\n}\n\n.language-selector-wrapper {\n  display: none; // Hide the old top selector\n}\n\n.language-selector-bottom {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: fit-content;\n  display: flex;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.language-dropdown-bottom {\n  padding: 8px 32px 8px 16px; // Reduced padding (was 10px 40px 10px 20px)\n  border: 2px solid #f7f2f2;\n  border-radius: 25px;\n  background: linear-gradient(90deg, #c8a74c, #e3c97a);\n  cursor: pointer;\n  font-size: 14px; // Reduced from 16px\n  font-weight: 600;\n  color: #fff;\n  min-width: 120px; // Reduced from 140px\n  text-align: center;\n  appearance: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n\n  // Style for dropdown options\n  option {\n    background: #fff;\n    color: #333;\n    padding: 8px;\n  }\n\n  option:hover {\n    background: #f0f0f0;\n  }\n\n  option:checked {\n    background: #e3c97a;\n    color: #fff;\n  }\n}\n\n.language-dropdown-bottom:focus {\n  outline: none;\n  border-color: #0a4c17;\n  box-shadow: 0 0 0 3px rgba(10, 76, 23, 0.3);\n}\n\n.language-dropdown-bottom:hover {\n  opacity: 0.9;\n}\n\n.arrow-wrapper-bottom {\n  position: absolute;\n  right: 12px; // Adjusted for smaller size\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #fff;\n\n  .dropdown-icon {\n    font-size: 12px; // Smaller icon\n  }\n}\n\n.timer-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin: 20px 0;\n  width: 100%;\n}\n\n.timer-badge {\n  background-color: #1a5f1a;\n  border-radius: 25px;\n  padding: 10px 10px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.timer-label {\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.timer-value {\n  color: white;\n  font-size: 48px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.timer-text {\n  color: #333;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.game-result {\n  margin-top: 15px;\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.puzzle-preview {\n  width: 80px;\n  height: 80px;\n  border: 1px solid #ccc;\n  overflow: hidden;\n  margin-right: 10px;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.claim-cashback {\n  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n  color: white;\n  padding: 4px;\n  border-radius: 4px;\n  &:hover {\n    background: darkgreen;\n    color: white;\n  }\n}\n\n.claim-cashback-lg {\n  font-size: 16px;\n  padding: 6px 12px;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.tooltip-container {\n  position: absolute;\n  right: 12px;\n  top: 25%;\n  transform: translateY(-25%);\n  display: inline-block;\n  z-index: 100;\n}\n\n.tooltip-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: help;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tooltip-icon:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.tooltip-content {\n  visibility: hidden;\n  opacity: 0;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) scale(0.9);\n  width: 280px;\n  max-width: 90vw;\n  background: #ffffff;\n  color: #333;\n  padding: 16px 20px;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.6;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  z-index: 99999;\n  transition: all 0.3s ease;\n  border: 1px solid #e0e0e0;\n}\n\n.tooltip-container:hover .tooltip-content {\n  visibility: visible;\n  opacity: 1;\n  transform: translate(-100%, -100%) scale(1);\n}\n\n/* Optional: Add backdrop */\n.tooltip-container:hover::after {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 9998;\n}\n\n.tnc-link {\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.terms-container {\n  min-height: 100vh;\n  background: #f5f5f5;\n  padding: 20px;\n  font-family: $regular;\n}\n\n.terms-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.terms-logo {\n  max-width: 150px;\n  margin-bottom: 15px;\n}\n\n.terms-header h1 {\n  color: #2c3e50;\n  font-size: 24px;\n  margin: 0;\n  font-family: $bold;\n}\n\n.terms-content {\n  background: white;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.terms-list {\n  counter-reset: item;\n  list-style: none;\n  padding-left: 0;\n}\n\n.terms-list > li {\n  counter-increment: item;\n  margin-bottom: 20px;\n  padding-left: 40px;\n  position: relative;\n  line-height: 1.7;\n  color: #34495e;\n  font-size: 14px;\n  text-align: justify;\n}\n\n.terms-list > li::before {\n  content: counter(item) \".\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  font-weight: 700;\n  color: #2c3e50;\n  font-size: 16px;\n}\n\n.sub-list {\n  margin-top: 15px;\n  padding-left: 20px;\n  list-style-type: upper-alpha;\n}\n\n.sub-list li {\n  margin-bottom: 12px;\n  line-height: 1.7;\n  color: #34495e;\n  font-size: 14px;\n}\n\n.privacy-link {\n  color: #3498db;\n  text-decoration: none;\n  word-break: break-all;\n  transition: color 0.3s ease;\n}\n\n.privacy-link:hover {\n  color: #2980b9;\n  text-decoration: underline;\n}\n\n.terms-footer {\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.back-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px 40px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.back-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);\n}\n\n.back-button:active {\n  transform: translateY(0);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .terms-container {\n    padding: 15px;\n  }\n\n  .terms-content {\n    padding: 20px 15px;\n  }\n\n  .terms-header h1 {\n    font-size: 20px;\n  }\n\n  .terms-list > li {\n    font-size: 13px;\n    padding-left: 30px;\n  }\n\n  .sub-list li {\n    font-size: 13px;\n  }\n\n  .back-button {\n    padding: 12px 30px;\n    font-size: 14px;\n  }\n}\n.checkbox-text {\n  font-size: 12px;\n}\n\n.tnc {\n  text-decoration: underline;\n  font-family: $bold;\n}\n\n.cashback-section {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n$primary-gold: #d4af68;\n$dark-green: #1a5f3a;\n$light-green: #2d7a4f;\n$white: #ffffff;\n$dark-text: #1a1a1a;\n$medium-text: #4a4a4a;\n$light-text: #6c757d;\n$border-color: rgba(255, 255, 255, 0.3);\n\n.admin-dashboard {\n  min-height: 100vh;\n  background: linear-gradient(135deg, $primary-gold 0%, #c9a55a 100%);\n  padding: 20px;\n\n  &__header {\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 32px;\n    font-weight: 700;\n    color: $dark-text;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  }\n\n  &__tab-container {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    margin-bottom: 30px;\n    max-width: 1400px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  &__export-btn,\n  button {\n    background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-size: 15px;\n    cursor: pointer;\n    margin-top: 12px;\n    transition: background 0.3s ease;\n    font-family: $regular;\n  }\n\n  &__export-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &__export-btn:hover,\n  button:hover {\n    background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);\n  }\n\n  &__tab-button {\n    flex: 1;\n    max-width: 600px;\n    padding: 15px 30px;\n    border: none;\n    background: $white;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 18px;\n    color: $dark-text;\n    border-radius: 15px;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n    &--active {\n      background: $dark-green;\n      color: $white;\n      box-shadow: 0 6px 12px rgba(26, 95, 58, 0.3);\n    }\n\n    &:hover:not(&--active) {\n      background: #f5f5f5;\n      transform: translateY(-2px);\n      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  &__content {\n    max-width: 1400px;\n    margin: 0 auto;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 30px;\n    border-radius: 20px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  }\n\n  &__section-title {\n    text-align: center;\n    font-size: 24px;\n    font-weight: 700;\n    color: $dark-text;\n    margin-bottom: 25px;\n    padding-bottom: 15px;\n    border-bottom: 2px solid $border-color;\n  }\n\n  &__filter-container {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    margin-bottom: 25px;\n    padding: 20px;\n    background: rgba(212, 175, 104, 0.1);\n    border-radius: 12px;\n  }\n\n  &__filter-group {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__filter-label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: $dark-text;\n  }\n\n  &__input {\n    padding: 10px 15px;\n    width: 220px;\n    border: 2px solid $border-color;\n    border-radius: 8px;\n    font-size: 14px;\n    background: $white;\n    color: $dark-text;\n\n    &:focus {\n      outline: none;\n      border-color: $dark-green;\n      box-shadow: 0 0 0 3px rgba(26, 95, 58, 0.1);\n    }\n\n    &::placeholder {\n      color: $light-text;\n    }\n  }\n\n  &__date-input {\n    padding: 10px 15px;\n    border: 2px solid $border-color;\n    border-radius: 8px;\n    font-size: 14px;\n    background: $white;\n    color: $dark-text;\n\n    &:focus {\n      outline: none;\n      border-color: $dark-green;\n      box-shadow: 0 0 0 3px rgba(26, 95, 58, 0.1);\n    }\n  }\n\n  &__apply-button {\n    padding: 10px 24px;\n    background: $dark-green;\n    color: $white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 8px rgba(26, 95, 58, 0.2);\n\n    &:hover {\n      background: $light-green;\n      transform: translateY(-2px);\n      box-shadow: 0 6px 12px rgba(26, 95, 58, 0.3);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  &__table-wrapper {\n    overflow-x: auto;\n    margin-bottom: 25px;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    background: $white;\n  }\n\n  &__table-head {\n    background: linear-gradient(135deg, $primary-gold 0%, #c9a55a 100%);\n  }\n\n  &__table-header {\n    padding: 16px 12px;\n    text-align: left;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n    font-weight: 700;\n    color: $dark-text;\n    font-size: 15px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  &__table-row {\n    border-bottom: 1px solid $border-color;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: rgba(212, 175, 104, 0.08);\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  &__table-cell {\n    padding: 14px 12px;\n    color: $medium-text;\n    font-size: 14px;\n  }\n\n  &__empty-cell {\n    padding: 40px 20px;\n    text-align: center;\n    color: $light-text;\n    font-style: italic;\n    font-size: 15px;\n  }\n\n  &__loading {\n    padding: 40px 20px;\n    text-align: center;\n    color: $dark-text;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  &__pagination-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n    padding: 20px;\n    background: rgba(212, 175, 104, 0.1);\n    border-radius: 12px;\n  }\n\n  &__pagination-info {\n    font-size: 14px;\n    color: $dark-text;\n    font-weight: 500;\n  }\n\n  &__pagination-controls {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n  }\n\n  &__pagination-button {\n    padding: 10px 20px;\n    border: 2px solid $border-color;\n    background: $white;\n    cursor: pointer;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: $dark-text;\n    transition: all 0.3s ease;\n\n    &:hover:not(:disabled) {\n      background: $dark-green;\n      color: $white;\n      border-color: $dark-green;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(26, 95, 58, 0.2);\n    }\n\n    &:disabled {\n      background: #f0f0f0;\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: $light-text;\n      border-color: #e0e0e0;\n    }\n  }\n\n  &__pagination-text {\n    padding: 10px 16px;\n    font-size: 14px;\n    color: $dark-text;\n    font-weight: 600;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 8px;\n  }\n\n  .tabs-wrap {\n    margin-bottom: 20px;\n    display: flex;\n    border-bottom: 1px solid #0a4c17;\n    button {\n      margin: 0 !important;\n    }\n\n    .tab {\n      padding: 12px 24px;\n      cursor: pointer;\n      font-weight: 500;\n      color: #000;\n      border-bottom: 2px solid transparent;\n      transition: all 0.2s;\n    }\n\n    .tab:hover {\n      color: #374151;\n      border-bottom-color: #6b7280;\n    }\n\n    .tab.active {\n      color: #0a4c17;\n      border-bottom-color: #0a4c17;\n      font-family: $bold;\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .admin-dashboard {\n    padding: 15px;\n\n    &__tab-container {\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    &__tab-button {\n      max-width: 100%;\n    }\n\n    &__content {\n      padding: 20px 15px;\n    }\n\n    &__filter-container {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__input {\n      width: 100%;\n    }\n\n    &__pagination-container {\n      flex-direction: column;\n      text-align: center;\n    }\n  }\n}\n\n.btn-home {\n  background: linear-gradient(0deg, #017a2f 0%, #0a4c17 100%);\n  color: #fff;\n  border: none;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 12px;\n  transition: background 0.3s ease;\n  font-family: \"Exo Regular\";\n  &:hover {\n    background: linear-gradient(0deg, #0a4c17 100%, #017a2f 0%);\n    color: white;\n  }\n}\n\n.otp-block {\n  width: 100%;\n  text-align: center;\n  margin-top: 40px;\n}\n\n.privacy-policy-container {\n  min-height: 100vh;\n  background-color: #f5f5f5;\n  padding: 20px 20px;\n\n  .privacy-policy-content {\n    max-width: 900px;\n    margin: 0 auto;\n    background: white;\n    padding: 40px;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n    @media (max-width: 768px) {\n      padding: 20px;\n    }\n\n    .main-title {\n      font-size: 28px;\n      font-weight: bold;\n      color: #1a1a1a;\n      margin-bottom: 20px;\n      line-height: 1.3;\n      text-align: center;\n\n      @media (max-width: 768px) {\n        font-size: 22px;\n      }\n    }\n\n    .effective-date {\n      text-align: center;\n      font-size: 16px;\n      color: #666;\n      margin-bottom: 30px;\n    }\n\n    .intro-text {\n      font-size: 14px;\n      line-height: 1.6;\n      color: #34495e;\n      margin-bottom: 20px;\n    }\n\n    .policy-section {\n      margin-bottom: 35px;\n\n      h2 {\n        font-size: 22px;\n        font-weight: bold;\n        color: #1a1a1a;\n        margin-bottom: 15px;\n        padding-bottom: 8px;\n\n        @media (max-width: 768px) {\n          font-size: 20px;\n        }\n      }\n\n      p {\n        font-size: 16px;\n        line-height: 1.6;\n        color: #333;\n        margin-bottom: 15px;\n      }\n\n      ul {\n        margin-left: 20px;\n        margin-bottom: 15px;\n\n        li {\n          font-size: 16px;\n          line-height: 1.8;\n          color: #333;\n          margin-bottom: 8px;\n        }\n      }\n\n      a {\n        color: #4a7dcc;\n        text-decoration: none;\n        font-weight: 500;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .subsection {\n        margin-bottom: 20px;\n\n        h3 {\n          font-size: 18px;\n          font-weight: 600;\n          color: #2c2c2c;\n          margin-bottom: 10px;\n        }\n      }\n\n      .contact-info {\n        background-color: #f9f9f9;\n        padding: 20px;\n        border-radius: 6px;\n        border-left: 4px solid #4a7dcc;\n\n        p {\n          margin-bottom: 10px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n\n    .consent-notice {\n      background-color: #fff9e6;\n      border: 2px solid #ffd700;\n      border-radius: 6px;\n      padding: 20px;\n      margin-top: 30px;\n\n      .checkbox-wrapper {\n        display: flex;\n        align-items: flex-start;\n        gap: 15px;\n\n        .privacy-checkbox {\n          width: 24px;\n          height: 24px;\n          min-width: 24px;\n          min-height: 24px;\n          margin-top: 2px;\n          cursor: pointer;\n          flex-shrink: 0;\n          appearance: auto;\n          -webkit-appearance: checkbox;\n          -moz-appearance: checkbox;\n        }\n\n        .checkbox-label {\n          font-size: 16px;\n          line-height: 1.6;\n          color: #333;\n          font-weight: 500;\n          cursor: pointer;\n          user-select: none;\n          flex: 1;\n        }\n      }\n    }\n  }\n}\n\n.resend-otp-section {\n  margin-top: 15px;\n  text-align: center;\n\n  .timer-text {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n\n    .timer-count {\n      font-family: $bold;\n      color: black;\n    }\n  }\n\n  .resend-btn {\n    //  max-width: fit-content;\n    //  padding: 4px 8px;\n    margin-top: 10px;\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.pagination {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  &__controls {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n  }\n\n  &__button {\n    padding: 4px 8px;\n    border: 1px solid #ccc;\n    background: white;\n    cursor: pointer;\n    border-radius: 8px;\n    color: black;\n\n    &--disabled {\n      background: #f0f0f0;\n      cursor: not-allowed;\n      color: #666;\n    }\n  }\n\n  &__info {\n    padding: 8px 12px;\n  }\n}\n\n.admin-login {\n  h2 {\n    font-family: $bold;\n  }\n  .form-card {\n    width: calc(100% - 20px);\n  }\n}\n\n.cancel-btn {\n  background: #000;\n\n  &:hover {\n    background: gray;\n  }\n}\n\n// PasswordModal.scss\n\n.password-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n\n  &__content {\n    background-color: white;\n    padding: 30px;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 400px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  }\n\n  &__title {\n    margin-bottom: 10px;\n    font-size: 20px;\n    color: #333;\n  }\n\n  &__description {\n    margin-bottom: 20px;\n    font-size: 14px;\n    color: #666;\n  }\n\n  &__form {\n    display: flex;\n    flex-direction: column;\n  }\n\n  input {\n    border: 1px solid rgb(204, 204, 204);\n  }\n\n  &__input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid rgb(204, 204, 204);\n    border-radius: 8px !important;\n    font-size: 14px;\n    margin-bottom: 15px;\n    box-sizing: border-box;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:disabled {\n      background-color: #f5f5f5;\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n\n  &__error {\n    background-color: #fee;\n    color: #c33;\n    padding: 10px;\n    border-radius: 6px;\n    margin-bottom: 15px;\n    font-size: 14px;\n    border: 1px solid #fcc;\n    animation: shake 0.3s;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n  }\n\n  &__button {\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &--cancel {\n      color: white;\n\n      background: #000;\n\n      &:hover {\n        background: gray;\n      }\n\n      &:disabled {\n        opacity: 0.6;\n      }\n    }\n\n    &--submit {\n      border: none;\n      color: white;\n\n      &:hover:not(:disabled) {\n        box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);\n      }\n\n      &:disabled {\n        background-color: #ccc;\n      }\n    }\n  }\n}\n\n// Animation for error shake\n@keyframes shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-5px);\n  }\n  75% {\n    transform: translateX(5px);\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .password-modal {\n    &__content {\n      padding: 20px;\n      width: 95%;\n    }\n\n    &__title {\n      font-size: 18px;\n    }\n\n    &__description {\n      font-size: 13px;\n    }\n\n    &__button {\n      padding: 12px 16px;\n      font-size: 13px;\n    }\n  }\n}\n\n.screen-count-table {\n  min-height: 280px;\n}\n\n\n.popover-content {\n  background-color: white;\n  color: black;\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.5;\n  max-width: 320px;\n  box-shadow: 0 10px 38px -10px rgba(0, 0, 0, 0.35);\n  z-index: 9999; /* Higher z-index */\n  animation: slideUpAndFade 0.2s ease-out;\n\n  p,ul>li{\n    font-size: 12px;\n    color: #000;\n  }\n}\n\n.popover-arrow {\n  fill: #fff; /* Changed from #333 to white */\n}\n\ntable {\n  position: relative;\n  z-index: 1;\n}\n\ndetails[open] summary span {\n  transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
